import React, { useEffect, useState } from 'react';
import deliverIcon from '../../assets/icons/ic_deliver.svg'
import IconTint from 'react-icon-tint';
import Dropdown from '../Dropdown';
import { useAtom } from 'jotai';
import { deliverTo, deliverItem, deliverFrom } from '../store/DataStore'; // ⬅️ NEW: deliverFrom

const DeliverPopup = ({ isOpen, children, onClose, onSend, locations, currentLocation }) => {
  const [show, setShow] = useState(isOpen);

  // Track user interactions separately so we don't overwrite choices on open
  const [isToTouched, setIsToTouched] = useState(false);
  const [, setIsFromTouched] = useState(false);

  const [selectedToLocation, setSelectedToLocation] = useAtom(deliverTo);
  const [selectedFromLocation, setSelectedFromLocation] = useAtom(deliverFrom); // ⬅️ NEW
  const [itemDelivered, setItemDelivered] = useAtom(deliverItem);

  const sortedLocations = locations
    .filter(location => location !== 'home base')
    .sort((a, b) => a.localeCompare(b));

  if (locations.includes('home base')) {
    sortedLocations.unshift('home base');
  }

  useEffect(() => {
    if (isOpen) {
      setShow(true);
      // Keep your existing behavior: default TO = currentLocation unless the user touched it
      if (!isToTouched) setSelectedToLocation(currentLocation);
      // For FROM we mirror Escort: leave blank/unknown unless user picks one
      // (i.e., do not auto-set FROM to current)
    } else {
      setShow(false);
      setTimeout(onClose, 200);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onClose, isToTouched, currentLocation, locations]);

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 200);
    setItemDelivered('');
    // keep the last selections as-is so the user can quickly repeat
    setSelectedToLocation(selectedToLocation);
    setSelectedFromLocation(selectedFromLocation);
    setIsToTouched(false);
    setIsFromTouched(false);
  };

  const handleSend = () => {
    // Pass structured payload (backward compatible if parent ignores args)
    onSend?.({
      item: itemDelivered,
      from: selectedFromLocation,
      to: selectedToLocation,
    });
    setShow(false);
    setTimeout(onClose, 200);
    setItemDelivered('');
    setSelectedToLocation(selectedToLocation);
    setSelectedFromLocation(selectedFromLocation);
    setIsToTouched(false);
    setIsFromTouched(false);
  };

  const setSelectedTo = (val) => {
    setIsToTouched(true);
    setSelectedToLocation(val);
  };

  const setSelectedFrom = (val) => {
    setIsFromTouched(true);
    setSelectedFromLocation(val);
  };

  const canSend =
    itemDelivered?.trim() !== '' &&
    (selectedFromLocation ?? '') !== '' &&
    (selectedToLocation ?? '') !== '';

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-[full] transition-opacity duration-200 ${show ? 'opacity-100' : 'opacity-0'}`}
      onClick={handleClose}
      style={{ display: show || isOpen ? 'block' : 'none' }}
    >
      <div
        className="relative top-20 mx-auto p-4 border w-fit shadow-lg rounded-md bg-white"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex justify-end">
          <button
            onClick={handleClose}
            className="text-black bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg p-0.5 text-sm ml-auto inline-flex items-center"
            aria-label="Close"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="-mt-4 flex flex-col items-center">{children}</div>

        <div className="flex flex-col gap-4 mt-2 mb-5">
          <div className="flex flex-row gap-4">
            <div className="flex-1 min-w-[300px]">
              <span className="font-heebo text-md font-light">Item</span>
              <input
                className="bg-[#3C5BD2] bg-opacity-10 px-2 py-4 h-7 mt-1 rounded-md w-full outline-none font-heebo font-light"
                placeholder="Item description"
                value={itemDelivered}
                onChange={(e) => setItemDelivered(e.target.value)}
              />
            </div>
          </div>

          {/* NEW: From + To row */}
          <div className="flex flex-row gap-4">
            <div>
              <span className="font-heebo text-md font-light">From</span>
              <Dropdown
                list={sortedLocations}
                setSelected={setSelectedFrom}
                selectedItem={selectedFromLocation}
                dropdownWidth={'250'}
              />
            </div>
            <div>
              <span className="font-heebo text-md font-light">To</span>
              <Dropdown
                list={sortedLocations}
                setSelected={setSelectedTo}
                selectedItem={selectedToLocation}
                dropdownWidth={'250'}
              />
            </div>
          </div>
        </div>

        <div className="w-full flex justify-center mt-14">
          {canSend ? (
            <div
              className="flex w-fit bg-[#152FF5] py-1.5 px-5 rounded-3xl items-center cursor-pointer"
              onClick={handleSend}
              role="button"
              aria-label="Confirm Deliver"
            >
              <span className="text-white font-heebo">Confirm Deliver</span>
              <IconTint src={deliverIcon} className="h-5 ml-2" color="#FFFFFF" />
            </div>
          ) : (
            <div className="flex w-fit bg-[#152FF5] py-1.5 px-5 rounded-3xl items-center opacity-50">
              <span className="text-white font-heebo">Confirm Deliver</span>
              <IconTint src={deliverIcon} className="h-5 ml-2" color="#FFFFFF" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeliverPopup;
